<template>
    <div class="exp-details container">
        <el-card class="top-action">
            <el-row>
                <el-col :span="8">
                    <h3>{{expData.taskName}}</h3>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="exp-details-map" :gutter="7">
            <el-col :span="14">
                <div class="map-right" ref="expCharst">1</div>
            </el-col>
            <el-col :span="10">
                <el-row class="map-left" :gutter="7">
                    <el-col :span="24">
                        <el-card shadow="never">
                            <p class="flag">
                                <span v-for="(item,index) in screen" :key="index" :class="{active:index===value}"
                                    @click="handActive(index)">{{item}}</span>
                            </p>
                            <el-table :data="tableData" height="300px">
                                <el-table-column label="序号" type="index" align="center" width="100px"></el-table-column>
                                <el-table-column label="姓名" prop="nickname" align="center"></el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row class="card-row-box">
            <el-col :span="24">
                <el-card class="lessonhead-card" shadow="never">
                    <el-row middle>
                        <el-col :span="24">
                            <el-row middle>
                                <el-col :span="16">
                                    <el-row>
                                        <div class="numbox">
                                            <p class="titledataname">最高分</p>
                                            <p class="titledatanum">{{baseData.maxScore}}</p>
                                        </div>
                                        <div class="numbox">
                                            <p class="titledataname">最低分</p>
                                            <p class="titledatanum">{{baseData.minScore}}</p>
                                        </div>
                                        <div class="numbox">
                                            <p class="titledataname">平均分</p>
                                            <p class="titledatanum">{{baseData.avgScore}}</p>
                                        </div>
                                        <div class="numbox">
                                            <p class="titledataname">准时提交率</p>
                                            <p class="titledatanum">{{`${(baseData.punctualSubNume/baseData.totalNum*100).toFixed(0)}%`}}</p>
                                        </div>
                                        <div class="numbox">
                                            <p class="titledataname">合格率</p>
                                            <p class="titledatanum">{{`${(baseData.passNum/baseData.totalNum*100).toFixed(0)}%`}}</p>
                                        </div>
                                    </el-row>
                                </el-col>
                                <el-col class="text-r" :span="8">
                                    <el-row>
                                        <el-col :span="12">
                                            <div class="lesson-partake" ref="lessonPartake"></div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="lesson-pass" ref="lessonPass"></div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-card shadow="never">
                <el-table :data="scoreData">
                    <el-table-column label="排名" type="index" align="center"></el-table-column>
                    <el-table-column label="姓名" prop="nickname" align="center"></el-table-column>
                    <el-table-column label="作业得分" align="center">
                        <template slot-scope="{row}">
                            <span
                                v-text="(row.score || row.score==0) ? row.score:'-'"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="提交时间" align="center">
                        <template slot-scope="{row}">
                            <span
                                v-text="row.submit_time? row.submit_time:'-'"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-row>
    </div>
</template>
<script>
import { getEntityByUid,getStatistics,getTaskStudentList } from '@/api/lab/tasks'

export default {
    data () {
        return {
            tableData: [],
            scoreData: [],
            value: '',
            screen: {
                noSubmit: '未提交学生名单',
                noMark: '未打分学生名单'
            },
            baseData: {
                maxScore: 0,
                minScore: 0,
                avgScore: 0,
                gradeNum:0,
                totalNum: 0,
                punctualSubNume: 0,
                subNum: 0,
                passNum: 0
            },
            page: {
                page: 1,
                limit: 10,
                total: 0
            },
            expData: {},
            expStudyScore: {
                poor: 0, // 偏差
                pass: 0, // 合格
                medium: 0, // 中等
                good: 0, // 良好
                excellent: 0 // 优秀
            },
            newArr: [],
            arr: {
                name: [],
                score: []
            }
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.getEntityByUidData()
            this.handActive()
        },
        timeTotal (t) { // 计算实验时长
            const m = Math.floor(t % 3600);
            if (t) {
                return Math.floor(t / 3600) + "时" + Math.floor(m / 60) + "分" + t % 60 + "秒"
            } else {
                return 0
            }
        },
        toFix (a) {
            return a ? a.toFixed(1) + '%' : 0
        },
        handActive (key) {
            let k = key;
            if (!k || !this.screen[k]) {
                k = Object.keys(this.screen)[0];
            }
            this.value = k;
            this.getLessonUserStatistics()
        },
        getLessonUserStatistics () {
            const { uid } = this.$route.params
            let params = {                
                taskUid: uid,
                sidx: 'll2u.username'
            }
            if (this.value == 'noSubmit')
                params.status = -1
            else if (this.value == 'noMark')
                params.status = 1
            getTaskStudentList(params).then(res => {
                this.tableData = res.list || []
            })
        },
        async getClassExpStatistics () {
            const uid = this.$route.params.uid
            await getStatistics(uid).then(res => {
                this.baseData = res.userBasic
                this.scoreData = res.userScoreRanking
            })
            this.scoreData.map(item => {
                this.arr.name.push(item.nickname)
                this.arr.score.push(item.score)
                let df = item.score
                let zf = this.expData.totalScore
                if (df < zf * 0.6) {
                    this.expStudyScore.poor += 1
                } else {
                    if (df < zf * 0.7) {
                        this.expStudyScore.pass += 1
                    } else if (df < zf * 0.8) {
                        this.expStudyScore.medium += 1
                    } else if (df < zf * 0.9) {
                        this.expStudyScore.good += 1
                    } else {
                        this.expStudyScore.excellent += 1
                    }
                }
            })
            this.initSubsectionChartExp()
            this.initLessonPartake()
            this.initLessonPass()
        },
        //各个实验分段统计
        initSubsectionChartExp () {
            let dom = this.$refs.expCharst
            let myChart = this.$echarts.init(dom)
            myChart.setOption({
                legend: {
                    x: 'left',
                    type: 'scroll',
                    itemWidth: 12,
                    itemHeight: 12,
                },
                series: [
                    {
                        name: '分段统计',
                        type: 'pie',
                        radius: '66%',
                        center: ['50%', '55%'],//距离左右，上下距离的百分比
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'inside',
                            },
                            emphasis: {
                                show: true,
                                align: 'center',
                                formatter: '{b}\n{d}%',
                                lineHeight: 24,
                                textStyle: {
                                    fontSize: '18',
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    //自定义颜色
                                    var colorList = ['#239bff', '#f56496', '#ffb419', '#b4eb32', '#5a64f0'];
                                    return colorList[params.dataIndex]
                                }
                            }
                        },
                        data: [
                            { value: this.expStudyScore.excellent, name: '优秀' },
                            { value: this.expStudyScore.good, name: '良好' },
                            { value: this.expStudyScore.medium, name: '中等' },
                            { value: this.expStudyScore.pass, name: '合格' },
                            { value: this.expStudyScore.poor, name: '偏差' }
                        ]
                    }
                ]
            })
        },
        async getEntityByUidData () {
            let uid = this.$route.params.uid
            await getEntityByUid(uid).then(res => {
                this.expData = res
            })
            this.getClassExpStatistics()
        },
        initLessonPartake () { //参与率
            let dom = this.$refs.lessonPartake
            let myChart = this.$echarts.init(dom)
            myChart.setOption({
                title: {
                    subtext: '参与率',
                    left: 'center',
                    top: -10
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '参与率',
                        type: 'pie',
                        radius: ['50%', '60%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center',
                                formatter: '{d}%'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: this.baseData.subNum,
                                name: '参与人数',
                                position: 'center',
                                label: {
                                    show: true
                                },
                                itemStyle: {
                                    color: '#41b2ad'
                                }
                            },
                            {
                                value: this.baseData.totalNum - this.baseData.subNum,
                                name: '未参与人数',
                                itemStyle: {
                                    color: '#D8D8D8'
                                }
                            }
                        ]
                    }
                ]
            })
        },
        initLessonPass () {  //合格率
            let dom = this.$refs.lessonPass
            let myChart = this.$echarts.init(dom)
            myChart.setOption({
                title: {
                    subtext: '合格率',
                    left: 'center',
                    top: -10
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '合格率',
                        type: 'pie',
                        radius: ['50%', '60%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center',
                                formatter: '{d}%'
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {
                                value: this.baseData.passNum,
                                name: '合格人数',
                                position: 'center',
                                label: {
                                    show: true
                                },
                                itemStyle: {
                                    color: '#41b2ad'
                                }
                            },
                            {
                                value: this.baseData.totalNum-this.baseData.passNum,
                                name: '未合格人数',
                                itemStyle: {
                                    color: '#d8d8d8'
                                }
                            }
                        ]
                    }
                ]
            })
        },
    }
}
</script>
<style lang="less">
.exp-details {
    .top-action {
        margin-bottom: 7px;
    }
    .exp-details-map {
        height: calc(430px - 4 * 2 * 7px);
        > div {
            height: 100%;
            .map-right {
                padding: 20px;
                background-color: #fff;
                height: 100%;
            }
            .map-left {
                .el-card {
                    height: calc(430px - 4 * 2 * 7px);
                    .flag {
                        font-size: 14px;
                        font-weight: 600;
                        text-align: center;
                        color: #999;
                        cursor: pointer;
                        span {
                            padding: 0 20px;
                        }
                        span:nth-of-type(1) {
                            border-right: 1px solid #dcdcdc;
                        }
                        .active {
                            color: #333;
                        }
                    }
                }
            }
        }
    }
    .numbox {
        border-right: 1px solid #f0f0f0;
        .titledataname {
            margin-top: 20px;
        }
        .titledatanum {
            height: 60px;
            line-height: 60px;
            font-size: 1.6em;
        }
    }
    .lesson-partake,
    .lesson-pass {
        height: 150px;
    }

    //滚动条样式
    .el-table--scrollable-y {
        /deep/.el-table__body-wrapper::-webkit-scrollbar {
            width: 10px;
        }
        /deep/.gutter {
            width: 10px !important;
        }
    }

    .el-table--scrollable-y {
        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
            background-color: #d8d8d8ff;
            border-radius: 5px;
            // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        }
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    .el-table--scrollable-y {
        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
            // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #fff;
            border-radius: 3px;
        }
    }
}
</style>